// Configuración de variables de entorno
export const config = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  API_TIMEOUT: 30000, // el listado tarda 3-6s; con 10s un upstream lento abortaba y reintentaba

  // EmailList Configuration
  EMAIL_LIST_VENDOR_ID: 44,
  EMAIL_LIST_IS_DELETE: 0,
  EMAIL_LIST_GENERIC_FILTER_FIELDS: 'emailListName',
  EMAIL_LIST_GENERIC_FILTER_VALUE: 'challenge_list',
  EMAIL_LIST_DEFAULT_LIMIT: 50,
  EMAIL_LIST_DEFAULT_START: 0,
  EMAIL_LIST_DEFAULT_SORT: 'emailListId',
  EMAIL_LIST_DEFAULT_DIR: 'ASC' as const,

  // Authentication Configuration
  AUTH_TOKEN_KEY: 'etempo_token',
  AUTH_EMBED_ID_KEY: 'etempo_embedId',

  // React Query Configuration
  QUERY_STALE_TIME: 5 * 60 * 1000, // 5 minutos
  QUERY_GC_TIME: 10 * 60 * 1000, // 10 minutos
  QUERY_RETRY_COUNT: 3,
  QUERY_REFETCH_ON_WINDOW_FOCUS: false,

  // Google Maps Configuration
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
} as const

export default config
























